import type { MailboxInfo } from "owa-client-types";
import { isAccountFeatureEnabled } from "owa-feature-flags";
import type { SearchScope } from "owa-search-service";
import isGenWebQueryOnTypeEligible from "./isGenWebQueryOnTypeEligible";
import isOriginalGenWebQueryOnTypeExperienceEnabled from "./isOriginalGenWebQueryOnTypeExperienceEnabled";

export interface QueryOnTypeQfOptions {
    isEnabled: boolean;
    shouldSuppressScopedSuggestions: boolean;
}

export default function getQueryOnTypeQfOptions(mailboxInfo: MailboxInfo, searchScope?: SearchScope): QueryOnTypeQfOptions {
    const isOriginalQueryOnTypeExperienceEnabled = isOriginalGenWebQueryOnTypeExperienceEnabled(mailboxInfo);
    
    return {
        isEnabled: isOriginalQueryOnTypeExperienceEnabled ||
            isAccountFeatureEnabled("sea-gwc-query-on-type-with-qf", mailboxInfo),
        shouldSuppressScopedSuggestions: isOriginalQueryOnTypeExperienceEnabled &&
            isGenWebQueryOnTypeEligible(searchScope, mailboxInfo),
    };
}
